document.addEventListener("DOMContentLoaded", function(event) {
  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('Size');
  if (sizeParam) {
    document.querySelectorAll(".color-swatch").forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    }); 
  } 

  document.querySelector('.original-selector').addEventListener('change', function() {
    let selectedSize = this.options[this.selectedIndex].getAttribute("option-size").toLowerCase();
    console.log(selectedSize);
    document.querySelectorAll(".color-swatch").forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + selectedSize);
      link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
    });  
  });

});

